module.exports = __webpack_public_path__ + "img/drt11.7b7c3c1d.png";